import { render, staticRenderFns } from "./WarningStep.vue?vue&type=template&id=8b1b1712&scoped=true&"
import script from "./WarningStep.vue?vue&type=script&lang=js&"
export * from "./WarningStep.vue?vue&type=script&lang=js&"
import style0 from "./WarningStep.vue?vue&type=style&index=0&id=8b1b1712&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b1b1712",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3358805848/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8b1b1712')) {
      api.createRecord('8b1b1712', component.options)
    } else {
      api.reload('8b1b1712', component.options)
    }
    module.hot.accept("./WarningStep.vue?vue&type=template&id=8b1b1712&scoped=true&", function () {
      api.rerender('8b1b1712', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/NewUI/components/customer/authorizations/shared/WarningStep.vue"
export default component.exports